define((require) => {
    "use strict";

    const _              = require("underscore");
    const AnimationModel = require("shared/ui/experience/widgets/animations/AnimationModel");

    /**
     * The model for a fade animation.
     *
     * @class FadeAnimationModel
     * @constructor
     */
    return AnimationModel.extend({
        defaults: _.extend({
            type: "fade"
        }, AnimationModel.prototype.defaults)
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/animations/fade/FadeAnimationModel.js